export default __webpack_public_path__ + "img/dUPGPpDy.7b583b3c.svg";